import React, { useEffect, useState, Fragment, useContext } from 'react';
import TableSection from 'components/sales/tableSection/tableSection';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import localization from 'assets/localization/localization';
import Notfound from 'pages/notfound';

const FollowUp = ({ match, getFollowUpListing, followUpList }) => {
  const Headers = [
    'ID',
    'Last Interaction Date',
    'Interaction Type',
    'Next Action Date',
    'Expected Closure',
    'Stage',
    'Deal Status',
    // 'Current Status',
    'Actions',
  ];
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [leadId, setleadId] = useState();
  const [activeFollowUp, setActiveFollowUp] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isRender, setIsRender] = useState(false);
  const [isPostSale, setIsPostSale] = useState(false);

  const createLead = async (team_id, department_id) => {
    if (department_id && department_id.includes(2)) {
      if (team_id && team_id.includes(7)) {
        setActiveFollowUp('add-follow-up-cop-resident');
      } else if (team_id && team_id.includes(9)) {
        setActiveFollowUp('add-follow-up-supply');
      } else if (team_id && team_id.includes(8)) {
        setActiveFollowUp('add-follow-up-cop-resident');
      } else {
        setActiveFollowUp('add-follow-up-b2bAlliances');
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      const postSales = (await JSON.parse(localStorage.getItem('postSales')))
        ? JSON.parse(localStorage.getItem('postSales'))
        : false;
      setIsPostSale(postSales);
      setTeamId([team]);
      setDepartmentId([deparment]);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead(teamId, departmentId);
    }
  }, [teamId, departmentId]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/viewPoc/${leadId}`}
          className="btn btn-transparent"
        >
          {localization.viewPOCs}
        </Link>
        {!isPostSale && (
          <Link
            to={`${baseUrl}/${activeFollowUp}/${leadId}`}
            className="btn btn-primary d-md-inline-block"
          >
            {localization.AddFollowUpTitle}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        )}
      </Fragment>
    );
  };

  useEffect(() => {
    setleadId(match.params.id);
  }, []);

  useEffect(() => {
    if (getFollowUpListing !== null && leadId)
      (async () => {
        setIsLoading(true);
        const res = await getFollowUpListing(leadId);
        if (res === null || res === '') {
          setIsRender(true);
        }
        setIsLoading(false);
      })();
  }, [getFollowUpListing, leadId]);

  useEffect(() => {
    const tableData = [
      'id',
      'last_call_date',
      'interaction_type',
      'next_action_date',
      'expected_closure',
      'stage',
      'deal_name',
      // 'status',
      
    ];
    if (
      followUpList &&
      followUpList.resultSets &&
      followUpList.resultSets.length
    ) {
      const data = followUpList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          })),
          {
            Actions: {
              name: 'View Details',
              link: `${baseUrl}/view-follow-up/${element.id}`,
            },
          }
        )
      );
      data && setListData(setPageCount);
      setPageCount(Math.ceil(followUpList.total / followUpList.per_page));
    }
  }, [followUpList]);

  useEffect(() => {
    setListData([]);
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getFollowUpListing(leadId, val.selected + 1);
    setIsLoading(false);
  };
  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={localization.followUpListing}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        pageCount={pageCount}
        srNo={followUpList?.from}
        onPageChange={onPageChange}
      />
    </Layout>
  );
};

export default FollowUp;
